import request from '@/util/request'

// 查询【请填写功能名称】列表
export function listSite(query) {
  return request({
    url: '/iot/site/list',
    method: 'get',
    params: query
  })
}

// 查询【请填写功能名称】详细
export function getSite(siteId) {
  return request({
    url: '/iot/site/' + siteId,
    method: 'get'
  })
}

// 新增【请填写功能名称】
export function addSite(data) {
  return request({
    url: '/iot/site',
    method: 'post',
    data: data
  })
}

// 修改【请填写功能名称】
export function updateSite(data) {
  return request({
    url: '/iot/site',
    method: 'put',
    data: data
  })
}

// 删除【请填写功能名称】
export function delSite(siteId) {
  return request({
    url: '/iot/site/' + siteId,
    method: 'delete'
  })
}
export function zoningAll(parentId) {
  return request({
    url: '/system/zoning/list/' + parentId,
    method: 'post'
  })
}

export function zoning(parentId) {
  return request({
    url: '/system/zoning/province/' + parentId,
    method: 'post'
  })
}


// 校验NAS
export function checkNasUser(data){
	return request({
		url: '/iot/nas/user/checkNasUser',
		method: 'post',
		data: data
	})
}


